export default __webpack_public_path__ + "images/E5.72d6e2b.png";